module.exports = __webpack_public_path__ + "img/bobufo_bobocoin.gm.d0bb3a3.png";